export default {
  placeholder: 'Vybrať farbu',
  color: {
    custom: 'Vlastná',
  },
  family: {
    black: 'Čierna',
    gray: 'Sivá',
    slate: 'Modrošedá',
    red: 'Červená',
    orange: 'Oranžová',
    yellow: 'Žltá',
    green: 'Zelená',
    teal: 'Teal',
    cyan: 'Azúrová',
    blue: 'Modrá',
    indigo: 'Indigo',
    purple: 'Fialová',
    pink: 'Ružová',
  },
};
